import { render, staticRenderFns } from "./attendee.menu.vue?vue&type=template&id=d23dbf14&scoped=true&"
import script from "./attendee.menu.vue?vue&type=script&lang=js&"
export * from "./attendee.menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23dbf14",
  null
  
)

export default component.exports